import type { Config } from "./client";
import { config } from "./client";
import { loadShellEnv } from "./loadShellEnv";

export { config, type Config } from "./client";

// We don't care what kind of promise
let shellEnvPromise: Promise<unknown> | null = null;

export async function loadConfig(): Promise<Config> {
  if (!shellEnvPromise) {
    shellEnvPromise = loadShellEnv();
  }
  await shellEnvPromise;
  return config;
}
